import HttpBaseService from '@/services/http/HttpBaseService'
import CheckinContent from '@/objects/CheckinContent'
// import OnboardingSlide from '@/objects/OnboardingSlide'
import DashboardContent from '@/objects/DashboardContent'

class ContentService extends HttpBaseService {

  fetchCheckinContent = async () => {
    const response = await this.executeRequest('/content-api/collections/check-in/entries/a989ea8c-29a6-4b57-a42e-382e557b191a', 'GET')
    return new CheckinContent(response.data)
  }

  fetchOnboardingSlides = async () => {
    // const response = await this.executeRequest('/content-api/collections/onboarding/entries?sort=order', 'GET')
    const response = await this.executeRequest('/api/content/onboarding/welcome', 'GET')
    // console.log(response2);
    return response.data.slide
  }

  fetchDashboardContent = async () => {
    const response = await this.executeRequest('/content-api/collections/dashboard/entries/0e802b1f-01d7-4306-9e8d-b2e833c57e26', 'GET')
    console.log('new DashboardContent(response.data): ', new DashboardContent(response.data))
    return new DashboardContent(response.data)
  }

  fetchFromCms = async (collection, slug) => {
    const response = await this.executeRequest(`/api/content/${collection}/${slug}`, 'GET')
    return response.data
  }


}

export default new ContentService()
